module.exports = __webpack_public_path__ + "static/img/46-3.8940cba.png";